import React from 'react';
import './Styles/Activity.scss';
import profile from '../../../Assets/Cards/profile1.png';
import {ReactComponent as Number} from '../../../Assets/Icons/number.svg';
const Activity=()=>{
    return(
        <div className="activity-c">
            <div className="content">
                <h1>Activity</h1>
                <p>Tracks activity across all projects. See and respond to new feedback for all your projects in one convenient place.</p>
            </div>
            <div className="imgpart">
                <div className="smallimg"></div>
                <div className="testimonial" data-aos="zoom-in"
              data-aos-delay={200}>
                  <Number className="number" />
                <div className="name">
                <img  src={profile} />
                <h3>John Petla</h3>
                </div>
                <p>we need more work here. Please add some images here.</p>
                <div className="post">
                    <p>Just Now</p>
                    <p> Mark as done</p>
                    <p>Reply</p>
                         </div>
                    </div>
            </div>
        </div>
    )
};
export default Activity ;